import Enum from "../../../../../../enums/Enum";

const AlcoholFrequencyEnum = new Enum({
    SOCIAL: {name: "Social Drinker"},
    MODERATE: {name: "Moderate Drinker"},
    HEAVY: {name: "Heavy Drinker"}
});

export default AlcoholFrequencyEnum;